module.exports = __webpack_public_path__ + "static/media/refund-success@3x.8ca61a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/refund/refund-success@3x.png
// module id = 2082
// module chunks = 6